import { Component, OnInit } from '@angular/core';
import { GlobalService } from '../../../global.service';
@Component({
  selector: 'app-netflix-terms',
  templateUrl: './netflix-terms.component.html',
  styleUrls: ['./netflix-terms.component.sass']
})
export class NetflixTermsComponent implements OnInit {
  
  public currentList;
  public postpago;
  public prepago;
  public telefoniaFijo;
  public totalAccountList;
  public selectBan;
  public token:string=sessionStorage.getItem("token");

  public content:object;
  public tabActive='Mis Equipos y Servicios';

  constructor(public global:GlobalService) { }

  ngOnInit() {
    this.content={
      content:[
        {
          title:"1.	Suscripción a Netflix ",
          description:"Requisitos y proceso para suscribirse al Servicio de Netflix",
          link:"../../assets/pdf/1_Suscripción a Netflix.pdf",
          expand:true
        },
        {
          title:"2.	Cuentas con clasificación “credit limit”",
          description:"Cuentas con clasificación “credit limit”",
          link:"../../assets/pdf/2_Cuentas con clasificación “Credit Limit”.pdf",
          expand:false
        },
        {
          title:"3.	Membresía de Netflix",
          description:"Membresía de Netflix",
          link:"../../assets/pdf/3_Membresía de Netflix.pdf",
          expand:false
        },
        {
          title:"4.	Mes de prueba de Netflix gratis",
          description:"Mes de prueba de Netflix gratis",
          link:"../../assets/pdf/4_Mes de prueba de Netflix gratis.pdf",
          expand:false
        },
        {
          title:"5.	Mensualidades y Cargos ",
          description:"Mensualidades y Cargos",
          link:"../../assets/pdf/5_Mensualidades y Cargos.pdf",
          expand:false
        },
        {
          title:"6.	Facturación",
          description:"Facturación",
          link:"../../assets/pdf/6_Facturación.pdf",
          expand:false
        },
        {
          title:"7.	Reembolsos",
          description:"Reembolsos",
          link:"../../assets/pdf/7_Reembolsos.pdf",
          expand:false
        },
        {
          title:"8.	Cambios en precio y planes de Netflix",
          description:"Cambios en precio y planes de Netflix",
          link:"../../assets/pdf/8_Cambios en precio y planes de Netflix.pdf",
          expand:false
        },
        {
          title:"9.	Consumo de Datos",
          description:"Consumo de Datos",
          link:"../../assets/pdf/9_Consumo de Datos.pdf",
          expand:false
        },
        {
          title:"10.	Averías e interrupción de servicios de Netflix",
          description:"Averías e interrupción de servicios de Netflix",
          link:"../../assets/pdf/10_Averías e interrupción de servicios de Netflix.pdf",
          expand:false
        },
        {
          title:"11.	Cambios en la Cuenta de CLARO",
          description:"Cambios en la Cuenta de CLARO",
          link:"../../assets/pdf/11_Cambios en la Cuenta de CLARO.pdf",
          expand:false
        },
        {
          title:"12.	Cambios o cancelaciones voluntarias en la cuenta de Netflix",
          description:"Cambios o cancelaciones voluntarias en la cuenta de Netflix",
          link:"../../assets/pdf/12_Cambios o cancelaciones voluntarias en la cuenta de Netflix.pdf",
          expand:false
        },
        {
          title:"13.	Contraseñas y acceso a la cuenta",
          description:"Contraseñas y acceso a la cuenta",
          link:"../../assets/pdf/13_Contraseñas y acceso a la cuenta.pdf",
          expand:false
        },
        {
          title:"14.	Suspensión de Servicio Netflix por cargo no cobrado",
          description:"Suspensión de Servicio Netflix por cargo no cobrado",
          link:"../../assets/pdf/14_Suspensión de Servicio Netflix por cargo no cobrado.pdf",
          expand:false
        },
        {
          title:"15.	Reclamaciones",
          description:"Reclamaciones",
          link:"../../assets/pdf/15_Reclamaciones.pdf",
          expand:false
        },
        {
          title:"16.	Códigos Promocionales",
          description:"Códigos Promocionales",
          link:"../../assets/pdf/16_Códigos Promocionales.pdf",
          expand:false
        },
        {
          title:"17.	Seguridad",
          description:"Seguridad",
          link:"../../assets/pdf/17_Seguridad.pdf",
          expand:false
        },
        {
          title:"18.	Cambios a los Términos y Condiciones",
          description:"Cambios a los Términos y Condiciones",
          link:"../../assets/pdf/18_Cambios a los Términos y Condiciones.pdf",
          expand:false
        }
      ]
    };
  }
  initializeData(){
    this.global.refreshDataTo(this.token);
  }


}
